export default "__VITE_ASSET___vIMn9O6__"